module.exports = __webpack_public_path__ + "static/media/modelA3.19e14cc4.gif";